import { useQuery } from "@tanstack/react-query";

import { PromotedCategoriesPanel } from "@/components/ui/admin/taxonomy/PromotedCategoriesPanel";
import { TaxonomyPanel } from "@/components/ui/admin/taxonomy/TaxonomyPanel";
import { createTaxonomyService } from "@/core/services/factory";
import { useTranslations } from "@/lib/useTranslations";

export function TaxonomyPage() {
  const t = useTranslations("taxonomy");

  const taxonomyQuery = useQuery({
    queryKey: ["taxonomy"],
    queryFn: () => createTaxonomyService().listAll(),
  });

  const promotedQuery = useQuery({
    queryKey: ["taxonomy-promoted"],
    queryFn: () => createTaxonomyService().listPromotedCategories(),
  });

  if (taxonomyQuery.isLoading || !taxonomyQuery.data || promotedQuery.isLoading) {
    return (
      <div className="mx-auto flex w-full max-w-6xl flex-1 items-center justify-center px-6 py-10 text-sm text-neutral-500">
        Chargement…
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {t("eyebrow")}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {t("title")}
        </h1>
      </header>

      <PromotedCategoriesPanel items={promotedQuery.data ?? []} />

      <TaxonomyPanel
        data={taxonomyQuery.data}
        promotedCategories={promotedQuery.data ?? []}
      />
    </div>
  );
}
